import React from "react";
import { cn } from "../../../lib/utils";
import { CARD, TILE } from "./classes";

const TONES = {
  card: CARD,
  raised: CARD,
  tile: TILE,
  positive: "bg-eh-sage/20 border border-eh-border-soft rounded-2xl",
};

/** The admin card (`bg-white rounded-2xl border border-eh-border-soft`); `tile` is a nested cream tile. */
export default function CrmCard({ as: Tag = "div", tone = "card", className, children, ...rest }) {
  return (
    <Tag className={cn("p-6", TONES[tone] || CARD, className)} {...rest}>
      {children}
    </Tag>
  );
}
